let routes = [
    // 煤沥青
    {
        path: 'asphalt',
        name: '煤沥青',
        component: () => import('@/views/asphalt/index'),
    },
    {
        path: 'asphalt/twoPage/industry',
        name: '煤沥青行业动态二级页',
        component: () => import('@/views/asphalt/twoPage/industry')
    },
    {
        path: 'asphalt/industry',
        name: '煤沥青行业动态详情页',
        component: () => import('@/views/asphalt/detail/industry')
    },
    {
        path: 'asphalt/twoPage/price',
        name: '煤沥青价格二级页',
        component: () => import('@/views/asphalt/twoPage/price')
    },
    {
        path: 'asphalt/price',
        name: '煤沥青价格详情页',
        component: () => import('@/views/asphalt/detail/price')
    },
    {
        path: 'asphalt/twoPage/report',
        name: '煤沥青研究报告二级页',
        component: () => import('@/views/asphalt/twoPage/report')
    },
    {
        path: 'asphalt/twoPage/standard',
        name: '煤沥青技术及标准二级页',
        component: () => import('@/views/asphalt/twoPage/standard')
    },
    {
        path: 'asphalt/twoPage/exit',
        name: '煤沥青进出口二级页',
        component: () => import('@/views/asphalt/twoPage/exit')
    },
    {
        path: 'asphalt/exit',
        name: '煤沥青进出口详情页',
        component: () => import('@/views/asphalt/detail/exit')
    },
    {
        path: 'asphalt/twoPage/yield',
        name: '煤沥青产量二级页',
        component: () => import('@/views/asphalt/twoPage/yield')
    },
    {
        path: 'asphalt/yield',
        name: '煤沥青产量详情页',
        component: () => import('@/views/asphalt/detail/yield')
    },
    {
        path: 'asphalt/twoPage/profit',
        name: '煤沥青利润二级页',
        component: () => import('@/views/asphalt/twoPage/profit')
    },
    {
        path: 'asphalt/profit',
        name: '煤沥青利润详情页',
        component: () => import('@/views/asphalt/detail/profit')
    },
    {
        path: 'asphalt/twoPage/yangPrice',
        name: '煤沥青预焙阳极价格二级页',
        component: () => import('@/views/asphalt/twoPage/yangPrice')
    },
    {
        path: 'asphalt/yangPrice',
        name: '煤沥青预焙阳极价格详情页',
        component: () => import('@/views/asphalt/detail/yangPrice')
    },
    {
        path: 'asphalt/twoPage/lvPrice',
        name: '煤沥青铝价格二级页',
        component: () => import('@/views/asphalt/twoPage/lvPrice')
    },
    {
        path: 'asphalt/lvPrice',
        name: '煤沥青铝价格详情页',
        component: () => import('@/views/asphalt/detail/lvPrice')
    },
    {
        path: 'asphalt/twoPage/rate',
        name: '煤沥青下游开工率二级页',
        component: () => import('@/views/asphalt/twoPage/rate')
    },
    {
        path: 'asphalt/rate',
        name: '煤沥青下游开工率详情页',
        component: () => import('@/views/asphalt/detail/rate')
    },
    {
        path: 'asphalt/twoPage/downYield',
        name: '煤沥青下游下游产量二级页',
        component: () => import('@/views/asphalt/twoPage/downYield')
    },
    {
        path: 'asphalt/downYield',
        name: '煤沥青下游下游产量详情页',
        component: () => import('@/views/asphalt/detail/downYield')
    },
    {
        path: 'asphalt/downYieldXin',
        name: '煤沥青下游下游产量资讯详情页',
        component: () => import('@/views/asphalt/detail/downYieldXin')
    },
    {
        path: 'asphalt/twoPage/downExit',
        name: '煤沥青下游下游进出口量二级页',
        component: () => import('@/views/asphalt/twoPage/downExit')
    },
    {
        path: 'asphalt/downExit',
        name: '煤沥青下游下游进出口量详情页',
        component: () => import('@/views/asphalt/detail/downExit')
    },
    {
        path: 'asphalt/twoPage/downStock',
        name: '煤沥青下游下游库存二级页',
        component: () => import('@/views/asphalt/twoPage/downStock')
    },
    {
        path: 'asphalt/downStock',
        name: '煤沥青下游下游库存详情页',
        component: () => import('@/views/asphalt/detail/downStock')
    },
    {
        path: 'asphalt/twoPage/downProfit',
        name: '煤沥青下游下游利润二级页',
        component: () => import('@/views/asphalt/twoPage/downProfit')
    },
    {
        path: 'asphalt/downProfit',
        name: '煤沥青下游下游利润详情页',
        component: () => import('@/views/asphalt/detail/downProfit')
    },
]
export default routes;
